import { z } from 'zod';

export const CustomElementsEnum = z.enum(['dm-kpi-summary']);

export type CustomElements = z.infer<typeof CustomElementsEnum>;

export const CUSTOM_ELEMENTS_LABELS: Record<CustomElements, string> = {
  ['dm-kpi-summary']: 'DM KPI Summary',
};
